export default __webpack_public_path__ + "static/media/Penny Bun6.e9afa4ae.jpg";